module.exports = __webpack_public_path__ + "static/media/wifi-wireless-internet-svgrepo-com.bb452c0a.svg";